import { render, staticRenderFns } from "./kankan.vue?vue&type=template&id=0abcfcf6&scoped=true&"
import script from "./kankan.vue?vue&type=script&lang=js&"
export * from "./kankan.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/data/kankan.less?vue&type=style&index=0&id=0abcfcf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abcfcf6",
  null
  
)

component.options.__file = "kankan.vue"
export default component.exports